module.exports = __webpack_public_path__ + "static/social-proof-mobile-4bc1c3a574c9e1fc0b9ea2e97d6a6ecc.jpg";